module.exports = __webpack_public_path__ + "static/media/ji2.f562af95.png";